import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { addVendor } from "../../services/vendorService";
import { errorToast, successToast } from "../Toasts/Toasts";

const VendorAddModal = ({ show, handleClose }) => {
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      available: false,
    },
  });

  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (name && location) {
      const vendorCode = `${name}-${location}`;
      setValue("vendorCode", vendorCode);
    }
  }, [name, location, setValue]);

  const onSubmit = async (data) => {
    try {
      const response = await addVendor(data);

      if (response) {
        successToast(response?.message);
        handleClear();

        navigate("/vendor");
        handleClose();
      }
    } catch (error) {
      errorToast(error?.response?.data?.message || "Something went wrong.");
    }
  };

  const handleInputChange = (fieldName, value) => {
    setValue(fieldName, value);
    if (value) {
      clearErrors(fieldName);
    }
  };

  const handleClear = () => {
    setLocation("");
    setName("");
    reset();
  };

  const handleSaveVendor = (data) => onSubmit(data);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Vendor Management</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(handleSaveVendor)}>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
              <label>
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                {...register("name", { required: "Required" })}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  handleInputChange("name", e.target.value);
                }}
              />
              {errors.name && <p className="text-danger">{errors.name.message}</p>}
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
              <label>
                Location <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Location"
                {...register("location", { required: "Required" })}
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                  handleInputChange("location", e.target.value);
                }}
              />
              {errors.location && <p className="text-danger">{errors.location.message}</p>}
            </div>

            <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
              <label>
                Vendor Code <span className="text-danger">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Vendor Code" {...register("vendorCode")} disabled />
            </div>

            <div className="col-12 d-flex justify-content-end">
              <Button type="submit" variant="outline-success btn-sm" className="me-2" onClick={handleSubmit(handleSaveVendor)}>
                Save
              </Button>
              <Button variant="secondary" onClick={handleClear}>
                Cancel
              </Button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default VendorAddModal;
